import { LoginSource } from '@ps/web-core-store';

import { FeatureFlag } from '@swf/core/enums';
import type { RequestError } from '@swf/core/errors/RequestError';
import idpLogin from '@swf/core/models/auth/idpLogin';
import type { EffectParams } from '@swf/core/store';
import { getState, select } from '@swf/core/store';
import type { BoundRequestOptions } from '@swf/core/types/Request';

import type { AuthError } from '.';
import { loginError, loginSuccess, sessionTransfer } from './utils';

export interface LoginPayload {
  userId: string;
  password: string;
  rsaCode?: string;
  rsa?: string;
  pin?: string;
  nemIdLoggedIn?: boolean;
  sessionTransfer?: boolean;
}

const login = async (payload: LoginPayload, { dispatch, request }: EffectParams) => {
  const rootState = getState();
  const { installId } = select.session.get(rootState);
  const isJWTEnabled = select.feature.check(rootState, FeatureFlag.JWTEnabled);
  const isIdpSecondaryLoginEnabled = select.feature.check(
    rootState,
    FeatureFlag.IdpSecondaryLoginEnabled
  );
  const { rsaCode, password } = payload;
  const temporaryPassword = password.startsWith('tmp') ? password : '';
  const options: BoundRequestOptions = {
    service: `auth.ram.${rsaCode ? 'rsa' : 'pwd'}`,
    body: { installId, ...payload }
  };

  if (isJWTEnabled) {
    options.service = '/api/v1-preview/auth/session';
    options.http = true;
    options.method = 'POST';

    if (payload.rsaCode) {
      payload.rsa = payload.rsaCode;
      delete payload.rsaCode;
    }
  }

  try {
    const { headers, body } = await (payload?.sessionTransfer
      ? sessionTransfer(options, { request })
      : request(options));

    await loginSuccess(
      { ...body, loginSource: LoginSource.Login },
      { dispatch, request },
      headers,
      temporaryPassword
    );

    if (isIdpSecondaryLoginEnabled) {
      idpLogin(payload, { dispatch, rootState });
    }
  } catch (err) {
    return loginError(payload, err as RequestError<AuthError>, dispatch);
  }
};

export default login;
